import { Pipe, PipeTransform } from '@angular/core';
import { EnumType } from '../../models/enums/enum';

@Pipe({
  name: 'translateErrorCode'
})
export class TranslateErrorCodePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value || typeof value !== 'string') { return value; }
    if (value === EnumType.ErrorCode.TOKEN_EXPIRED) {
      return 'SESIÓN EXPIRADA';
    } else if (value === EnumType.ErrorCode.SERVER_UNAVAILABLE) {
      return 'SERVICIO NO DISPONIBLE';
    } else if (value === EnumType.ErrorCode.SERVER_ERROR) {
      return 'FALLO DEL SERVICIO';
    } else if (value === EnumType.ErrorCode.SERVER_TIMEOUT) {
      return 'TIEMPO DE ESPERA AGOTADO';
    } else if (value === EnumType.ErrorCode.EMPTY_RESULT) {
      return 'SIN RESULTADOS';
    } else {
      return value;
    }
  }

}
